
import { MediaMatcher } from '@angular/cdk/layout';
import {ChangeDetectorRef, Component,OnDestroy,AfterViewInit,OnInit, ViewChild} from '@angular/core';
import { MatDrawerContainer } from '@angular/material/sidenav';
import { userAccess } from '../models/UserAccess';
import { UserService } from '../services/User/user.service';
import { MenuItems } from 'src/app/shared/menu-items/menu-items';
import { environment } from 'src/environments/environment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
/** @title Responsive sidenav */

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css'],
    standalone: false
})

export class LayoutComponent implements OnDestroy, AfterViewInit {
  @ViewChild(MatDrawerContainer) drawerContainer!: MatDrawerContainer;
  mobileQuery: MediaQueryList;
  isExpanded:boolean=false;
  private _mobileQueryListener: () => void;
  userAccessData!: userAccess;//this variable will hold user data

  environment : string = "";
  envColor : string = "";
  envTextColor : string = "";
   isHandset: boolean = false;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private userService: UserService,
    public menuItems: MenuItems,
    private breakpointObserver: BreakpointObserver
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.userAccessData = this.userService.getUsersAccessData();

     this.breakpointObserver.observe([Breakpoints.Handset])
      .subscribe(result => {
          if (result.matches) {
          // On mobile view
          this.isExpanded = true;
        }else{
          this.isExpanded = false;
        }
      });
  }

  ngOnInit(): void {
    const baseURL = environment.baseURL;
    if (environment.production == false) {
      if (baseURL.includes('dev')) {
        this.environment = 'DEV MODE';
        this.envColor = "#B5EEE8"
        this.envTextColor = "#39AE86"

      } else if (baseURL.includes('qa')) {
        this.environment = 'QA MODE';
        this.envColor = "#F7DAC6"
        this.envTextColor = "#E19259"

      } else if (baseURL.includes('staging')) {
        this.environment = 'UAT MODE';
        this.envColor = "#F6DFFD"
        this.envTextColor = "#B480C4"
      }
    }
    console.log('Environment set to:', this.environment);

  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
  ngAfterViewInit() {}

  getTooltipText(): string {
    return !this.isExpanded? 
      "Collapse" : 
      "Expand";
  }

  toggleSidebar(): void {
    this.isExpanded = !this.isExpanded;
    // Wait for the drawer width to update in the DOM, then recalculate content margins
    setTimeout(() => {
      this.drawerContainer.updateContentMargins();
    }, 0);
  }

  clearSessionStorage() {
    sessionStorage.removeItem('parent');  
    sessionStorage.removeItem('activeChild');  
    sessionStorage.removeItem('isExpandedItem');  
    sessionStorage.removeItem('expandedItem'); 
    sessionStorage.removeItem('Child'); 
    sessionStorage.removeItem('expandedStateChild'); 
    

    this.menuItems.setAccessLinks();
  }
}